import React from 'react'
import { withRouter } from 'react-router'
import { List, Typography } from 'antd'

import { reqSiteDatasource } from '../../api'
const { Paragraph } = Typography

class Datasource extends React.Component {
    state = {
        datasource: [],
        res_component : ''
    }

    async componentDidMount() {
        const id = this.props.match.params.id
        const res = await reqSiteDatasource(id)
	let res_component = ''
        let datasource = []
        if (res.code === 0) {
            datasource = res.data
        }

        if (id) {
            res_component = <div style={{overflow: 'auto'}} dangerouslySetInnerHTML = {{ __html: datasource['content'] }}></div>
        } else {
            res_component = <List
                size="small"
                header={<div>Datasource</div>}
                bordered
                dataSource={datasource}
                renderItem={ (item) => 
                    <a href={`/tomato/datasource/${item['id']}`}><List.Item>{item['title']}</List.Item></a>
                }
            />
        }

        this.setState({res_component: res_component})
    }

    render() {
        const { res_component } = this.state
        return (
            <React.Fragment>{res_component}</React.Fragment>
        )
    }
}


export default withRouter(Datasource)
